const mergeHistoryEventsData = (existing, incoming, readField) => {
  const existingHistoryEvents = existing?.historyEvents || [];
  const incomingHistoryEvents = incoming?.historyEvents || [];

  const existingHistoryEventIds = existingHistoryEvents.map((historyEvent) => readField('id', historyEvent));
  const newHistoryEvents = incomingHistoryEvents.filter(
    (historyEvent) => !existingHistoryEventIds.includes(readField('id', historyEvent)),
  );

  return {
    meta: incoming.meta,
    historyEvents: [...existingHistoryEvents, ...newHistoryEvents],
  };
};

export default mergeHistoryEventsData;
